<div class="form-group-context">
  @for (groupHtml of formGroupAtpHtml(); track groupHtml; let groupHtmlIndex = $index) {
  <form
    [formGroup]="groupHtml.formGroup"
    class="p-1 pl-2 mb-3 mat-elevation-z1 d-flex flex-column"
    [ngClass]="{
      'form-group-main': groupHtml.configType === 'MAIN',
      'form-group-domain': groupHtml.configType === 'DOMAIN',
      'form-group-domain-list': groupHtml.configType === 'DOMAIN_LIST'
    }"
  >
    <mat-accordion>
      <mat-expansion-panel class="mat-elevation-z0" (opened)="groupHtml.isPanelOpen = true" (closed)="groupHtml.isPanelOpen = false">
        <mat-expansion-panel-header>
          @if (!groupHtml.isPanelOpen) {
          <mat-panel-title>
            {{ groupHtml.formGroup.controls.name.value }}
          </mat-panel-title>
          }
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <app-voucher-atp-form-header
            [groupHtml]="groupHtml"
            [formGroupContextBase]="groupHtml.formGroup"
            [canModify]="canModify()"
            (remove)="removeContextBase.emit(groupHtmlIndex)"
          ></app-voucher-atp-form-header>

          @for (propName of (groupHtml.propList | objectKeys); track propName) {
          <div class="mb-1 pl-1">
            @switch (propName) {
            <!-- ENABLED MODULES -->
            @case ('enabledModules') {
            <h3 class="m-0 font-weight-bold">{{ propName | titlecase }}</h3>
            <div class="pl-2">
              <app-voucher-atp-inputs
                [type]="'enabledModules'"
                [label]="groupHtml.propList[propName]"
                [formControlName]="groupHtml.propList[propName]"
                [canModify]="canModify()"
              ></app-voucher-atp-inputs>
            </div>
            }
            <!-- PARAMETERS -->
            @case ('parameters') {
            <app-voucher-atp-parameters
              [title]="groupHtml.propList.parameters.title | titlecase"
              [formArray]="groupHtml.propList.parameters.formArray"
              [type]="'parameters'"
              [canModify]="canModify()"
              (addParameters)="addParameters($event, 'parameters')"
            ></app-voucher-atp-parameters>
            }
            <!-- SECURE PARAMETERS -->
            @case ('secureParameters') {
            <app-voucher-atp-parameters
              [title]="groupHtml.propList.secureParameters.title | titlecase"
              [formArray]="groupHtml.propList.secureParameters.formArray"
              [type]="'secureParameters'"
              [canModify]="canModify()"
              (addParameters)="addParameters($event, 'secureParameters')"
            ></app-voucher-atp-parameters>
            }
            <!-- SUBCONFIG -->
            @case ('subConfig') { @for (arraySubConfig of groupHtml.propList.subConfig.controls; track $index) {
            <div class="mt-3 w-100 d-flex justify-content-between">
              <h3 class="font-weight-bold">
                {{ arraySubConfig.controls.name.value | titlecase }}
              </h3>
              <button mat-raised-button type="button" color="accent" [disabled]="!canModify()" (click)="addNewSubConfig(arraySubConfig)">
                <mat-icon>plus_one</mat-icon>
              </button>
            </div>
            @for (subconfig of arraySubConfig.controls.subConfig.controls; track subconfig; let i = $index) {
            <app-voucher-atp-form
              [formGroupAtpHtml]="subconfig | contextBaseToAtpHtml"
              [canModify]="canModify()"
              (removeContextConfig)="arraySubConfig.controls.subConfig.removeAt(i)"
            ></app-voucher-atp-form>
            } } } @default {
            <p>Invalid InputName: {{ propName }}</p>
            } }
          </div>
          }
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </form>

  }
</div>

